import type { WidgetPlacement } from './types';

const COLS = 12;
const MAX_SCAN_ROWS = 100;

/**
 * Find the first empty grid position for a widget of the given size.
 * Scans row-by-row, column-by-column on a 12-column grid.
 */
export function findEmptyPosition(
  existing: WidgetPlacement[],
  w: number,
  h: number,
): { x: number; y: number } {
  const occupied = new Set<string>();
  for (const wp of existing) {
    for (let row = wp.y; row < wp.y + wp.h; row++) {
      for (let col = wp.x; col < wp.x + wp.w; col++) {
        occupied.add(`${col},${row}`);
      }
    }
  }

  for (let row = 0; row < MAX_SCAN_ROWS; row++) {
    for (let col = 0; col <= COLS - w; col++) {
      let fits = true;
      for (let dy = 0; dy < h && fits; dy++) {
        for (let dx = 0; dx < w && fits; dx++) {
          if (occupied.has(`${col + dx},${row + dy}`)) {
            fits = false;
          }
        }
      }
      if (fits) return { x: col, y: row };
    }
  }

  const maxY = existing.reduce((max, wp) => Math.max(max, wp.y + wp.h), 0);
  return { x: 0, y: maxY };
}
